import { AudioHelper } from "../../../../library-js/audio/AudioHelper";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import UndoManager from "../../../../library-js/undo/UndoManager";
import { Rokojori } from "../../Rokojori";
import { RokojoriWebApp } from "../rokojori/RokojoriWebApp";
import { AudioEditorCommandsManager } from "./commands/AudioEditorCommandsManager";
import { AudioEditorProject } from "./project/AudioEditorProject";
import { AudioEditorSelection } from "./selection/AudioEditorSelection";
import { AudioEditorUI } from "./ui/AudioEditorUI";
import { InspectorCreator } from "../../../../library-templates/inspector/InspectorCreator";
import { ExportSettings } from "./project/exporting/ExportSettings";

export class AudioEditor extends RokojoriWebApp<AudioEditor,AudioEditorProject>
{
  static readonly type = new ElementType( "audio-editor" );

  static applyOnDocument( rokojori:Rokojori )
  {
    AudioEditor.type.forAllInDoc( e => this.applyOnElement( e, rokojori ) );
  } 

  static applyOnElement( e:Element, rokjori:Rokojori )
  {
    let editor = new AudioEditor( rokjori );
    editor.start( e );

    AudioHelper.onContextAvailable(
      ( ac )=>
      {
        editor._audioContext = ac;
      }
    );

  }
  
  protected _ui:AudioEditorUI;
  get ui() { return this._ui; }

  protected _audioContext:AudioContext;
  get audioContext() { return this._audioContext };

  
  get commandsManager()
  {
    return this._commandsManager as AudioEditorCommandsManager;
  }

  async start( e:Element )
  {
    this._contextSelections = [ new AudioEditorSelection() ];
    this._commandsManager = new AudioEditorCommandsManager( this );
    this._undoManager = new UndoManager();
   

    this._ui = new AudioEditorUI( e, this );
    await this._ui.initialize();

    this._project = new AudioEditorProject();

    this._project.exportSettings.logSettings.setCallback(
      ()=>
      {
        console.log( this._project.exportSettings );
      }
    );

    this._project.exportSettings.sliceClips.setCallback(
      ()=>
      {
        this.commandsManager.sliceClips.run();
      }
    );

    this._project.exportSettings.exportAllClips.setCallback(
      ()=>
      {
        this.commandsManager.exportAudio.run();
      }
    );

    this.updateInspector();
    
  }

  updateInspector()
  {
    let creator =  InspectorCreator.with( Rokojori.$.templatesManager );
    let inspector = creator.create( this._project.exportSettings );
    this._ui._inspectorView.clearChildren();

    console.log( inspector );
    this._ui._inspectorView.element.appendChild( inspector.element );
    

  }

}